import ValidateStep from "./validateStep"

/**
 * ValidateStep2 class
 * @extends ValidateStep
 * @classdesc This class is used to validate the second step of the form
 * mainly for the "Rinder mit Ohrmarkennummern" category.
 */
export default class ValidateStep2 extends ValidateStep {
    constructor(cPM, user, btn) {
        super(cPM, user, btn)
        this.cPM = cPM
        this.user = user
        this.count = document.querySelector("#powermail_field_sfg1")
        this.gender = document.querySelector("#powermail_field_sfg2")
        this.date = document.querySelector("#powermail_field_sfg3")
        this.omn = document.querySelector("#powermail_field_omn")
        this.omnFlag = document.querySelector("#powermail_field_omn_country")
        this.aAdress = document.querySelectorAll("input[name='tx_powermail_pi1[field][aadress]']")
        this.activeArticle = undefined
        this.continueButton = btn
        this.errorField = document.querySelector(".powermail_fieldwrap_errorlist-step2")
        this.setEventsForAllInputs()
        this.initButton()

        if (this.gender) {
            document.querySelector(".powermail_fieldwrap_sfg2").classList.add("hidden")
        }
    }

    /**
     * validates all fields of the second step - for "Rinder mit Ohrmarkennummern"-category
     * @returns {boolean} validation result
     */
    validateAll() {
        if (
            this.checkCount() == true &&
            this.checkDate() == true &&
            this.checkOmn() == true &&
            this.checkOmnFlag() == true &&
            this.checkAAdress() == true
        ) {
            this.cPM.step2Valid = true
            this.hideError()
            if (this.continueButton) {
                this.continueButton.removeAttribute("disabled")
                return true
            }
        } else {
            // get first error and scroll to parent element
            this.cPM.scrollToElement(".powermail_field_error", true)
            this.cPM.step2Valid = false
            this.showError()
            if (this.continueButton) {
                this.continueButton.setAttribute("disabled", "disabled")
                return false
            }
        }
    }

    /**
     * simple validation of the second step of the form - with count and aAdress
     * @returns {boolean} validation result
     */
    validateSimple() {
        if (this.checkCount() == true && this.checkAAdress() == true) {
            this.cPM.step2Valid = true
            this.valid = true
            if (this.continueButton) {
                this.continueButton.removeAttribute("disabled")
            }
            this.hideError()
            return true
        } else {
            this.cPM.step2Valid = false
            this.valid = false
            if (this.continueButton) {
                this.continueButton.setAttribute("disabled", "disabled")
            }
            this.showError()
            return false
        }
    }

    /**
     * simple validate function
     * @returns {boolean} validation result
     */
    validate() {
        var art = this.activeArticle,
            valid = false
        if (art.id == "powermail_field_rbg1_2") {
            valid = this.validateAll()
        } else if (this.activeArticle) {
            valid = this.validateSimple()
        } else {
            console.warn("validateStep2: no active article set")
        }
        return valid
    }

    /**
     * checks if the given input is not null or empty
     * @returns {boolean} validation result
     */
    checkCount() {
        let elem = this.count
        elem.valid = this.checkIfValue(elem)
        if (elem.valid) {
            this.removeError(elem)
        } else {
            this.showSpecificError(elem, "Bitte geben Sie die Anzahl der Rinder an.")
        }
        return elem.valid
    }

    /**
     * checks if the given input is empty or '-'
     * @returns {boolean} validation result
     */
    checkGender() {
        let elem = this.gender
        if (elem.value === "" || elem.value === "-") {
            elem.valid = false
            this.showSpecificError(elem, "Bitte wählen Sie ein Geschlecht aus.")
        } else {
            elem.valid = true
            this.removeError(elem)
        }
        return elem.valid
    }

    /**
     * checks if the given input is empty or invalid
     * @returns {boolean} validation result
     */
    checkDate() {
        let elem = this.date
        if (this.checkIfValue(elem) && this.checkForDateFormat(elem)) {
            if(this.checkDateForPastTime(elem)) {
                elem.valid = true
                this.removeError(elem)
            } else {
                elem.valid = false
                this.showSpecificError(elem, "Bitte geben Sie ein gültiges Datum ein, es darf nicht in der Zukunft liegen.")
            }
        } else {
            elem.valid = false
            this.showSpecificError(elem, "Bitte geben Sie ein gültiges Datum ein.")
        }
        return elem.valid
    }

    /**
     * checks if the given input is empty or invalid
     * @returns {boolean} validation result
     */
    checkOmn() {
        let elem = this.omn
        if (this.checkIfValue(elem) && this.checkOmnFlag()) {
            if ((this.omnFlag.value === "DE" || this.omnFlag.value === "FR") && elem.value.length === 10) {
                elem.valid = true
                this.removeError(elem)
            } else if ((this.omnFlag.value === "AT" || this.omnFlag.value === "CZ") && elem.value.length === 9) {
                elem.valid = true
                this.removeError(elem)
            } else {
                elem.valid = false
                this.showSpecificError(elem, "Bitte geben Sie eine gültige Ohrmarkennummer ein.")
            }
        } else {
            elem.valid = false
            this.showSpecificError(elem, "Bitte geben Sie eine gültige Ohrmarkennummer ein.")
            console.warn(
                "checkOmn: Invalid OMN or country flag not selected",
                this.omnFlag.value,
                elem.value.length,
                " - if you see smth like this: 'DE 0' 'CZ 0', it is because the omn is already cleared"
            )
        }
        return elem.valid
    }

    /**
     * checks if the given input is empty or invalid
     * @returns {boolean} validation result
     */
    checkOmnFlag() {
        let elem = this.omnFlag
        if (this.checkIfValue(elem)) {
            elem.valid = true
            this.removeError(elem)
        } else {
            elem.valid = false
            this.showSpecificError(elem, "Bitte wählen Sie ein Land aus.")
        }

        return elem.valid
    }

    /**
     * checks if the given input is empty or invalid
     * @returns {boolean} validation result
     */
    checkAAdress() {
        let elem = this.aAdress
        let valid = false

        // if one is checked, valid is true
        elem.forEach((input) => {
            if (input.checked) {
                valid = true
            } else if (elem.length == 1) {
                input.checked = this.checkIfValue(input)
            }
        })

        if (valid) {
            this.clearError(elem)
            this.removeError(elem)
            // console.log("---------------- checkAAdress: at least one address is checked");
            return true
        } else {
            this.addError(elem)
            this.showSpecificError(elem, "Bitte wählen Sie eine Adresse aus.")
            this.disableContinueButton()
            return false
        }
    }

    checkDateForPastTime(elem) {
        if (this.checkForDateFormat(elem)) {
            // check if date is in the past
            const dateParts = elem.value.split("-")
            if (dateParts.length === 3) {
                const year = parseInt(dateParts[0], 10)
                const month = parseInt(dateParts[1], 10) - 1 // Months
                const day = parseInt(dateParts[2], 10)
                const date = new Date(year, month, day)
                const today = new Date()
                // Set time to 00:00:00 for both dates
                date.setHours(0, 0, 0, 0)
                today.setHours(0, 0, 0, 0)
                if (date >= today) {
                    // console.warn("checkDateForPastTime: Date is in the future", date)
                    return false
                } else {
                    // console.log("checkDateForPastTime: Date is valid", date)
                    return true
                }
            }
        } else {
            // console.warn("checkDateForPastTime: Invalid date format", elem.value)
        }
        return false
    }

    checkForDateFormat(elem) {
        // dont actually check the format, check if year got 4 digits, not starting with a 0
        if (elem.value) {
            const dateParts = elem.value.split("-")
            if (dateParts.length === 3) {
                const year = dateParts[0]
                // Check if year is 4 digits and does not start with 0
                if (year.length === 4 && year[0] !== "0") {
                    return true
                } else {
                    // console.warn("checkForDateFormat: Invalid year format", year)
                }
            }
        }
        return false
    }

    /**
     * sets the events for all inputs
     * @returns {void}
     */
    setEventsForAllInputs() {
        try {
            this.onlyNumbers(this.omn)
            this.count.addEventListener("change", () => {
                this.checkCount()
            })
            // this.gender.addEventListener("change", () => {
            //     this.checkGender()
            // })
            this.date.addEventListener("change", () => {
                this.checkDate()
            })
            this.omn.addEventListener("change", () => {
                this.checkOmn()
            })
            this.omnFlag.addEventListener("change", () => {
                this.checkOmnFlag()
            })
            this.aAdress.forEach((input) => {
                input.addEventListener("change", (inp) => {
                    this.checkAAdress(inp)
                })
            })
        } catch (error) {
            console.error("Error setting events for inputs in ValidateStep2:", error)
        }
    }

    /**
     * sets the event for the continue button
     */
    initButton() {
        if (this.continueButton) {
            this.continueButton.addEventListener("click", (e) => {
                this.validate()
            })
        }
    }

    /**
     * sets the active article
     * @param {Object|string} article - article object / name
     */
    setActiveArticle(article, value) {
        if (article && value !== "") {
            this.activeArticle = article
        }
    }

    showSpecificError(elem, optional_text) {
        if (!elem) return

        let text = optional_text || "Bitte füllen Sie dieses Feld aus."
        // console.log("ERROR AT VALIDATION: showSpecificError: " + text , elem);

        // Prüfen, ob bereits ein Error-Element existiert
        try {
            let existingError = elem.parentElement.querySelector(".custom-error-message")
            if (existingError) {
                // Wenn schon vorhanden, nur den Text aktualisieren
                existingError.textContent = text
                return
            }
        } catch (error) {
            // console.debug("showSpecificError: Error finding existing error element", error);
        }

        // Neues Error-Element erstellen
        const errorElement = document.createElement("div")
        errorElement.classList.add("custom-error-message")
        errorElement.classList.add("powermail_field_error")
        errorElement.textContent = text

        // Error-Element nach dem Eingabefeld einfügen
        try {
            elem.after(errorElement)
        } catch (error) {
            // console.debug("ERROR: showSpecificError: Error inserting error element after input", error);
        }
    }

    removeError(elem) {
        let existingError
        if (!elem) return

        try {
            existingError = elem.parentElement.querySelector(".custom-error-message")
            if (existingError) {
                existingError.remove()
                // console.log("removeError: removing error for element", elem);
            }
        } catch (error) {
            // console.debug("removeError: Error finding existing error element", error);
        }
    }

    // showError() {
    //     let elem = document.querySelector(".powermail_fieldset_9 .powermail_tab_navigation");
    //     var field = document.createElement("span");
    //     field.classList.add("powermail_error");
    //     field.innerText = "Bitte füllen Sie alle Pflichtfelder aus.";
    //     if(elem) {
    //         elem.appendChild(field);
    //     }
    //     console.warn("showError: Please fill in all required fields.");
    //     if(this.continueButton) {
    //         this.continueButton.setAttribute("disabled", "disabled");
    //     }
    // }

    // hideError() {
    //     let elem = document.querySelector(".powermail_fieldset_9 .powermail_tab_navigation  span");
    //     if(elem) {
    //         let error = elem.querySelector(".powermail_error");
    //         if(error) {
    //             error.remove();
    //         }
    //         elem.remove();
    //     }
    //     console.log("hideError: No errors found, all fields are valid.");
    //     if(this.continueButton) {
    //         this.continueButton.removeAttribute("disabled");
    //     }
    // }
}
